export default "__VITE_ASSET__0dd40a3c__"